import { cookies } from '../_helpers'

export const menuServices = {
    getMenuList,
}

function getMenuList() {
    const requestOptions = {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'X-CSRFToken': cookies.getCookie('csrftoken'),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }

    return fetch('/api/place-types/', requestOptions)
        .then(res => res.json())
        .then(data => data)
}
